import LoadMoreProducts from './loadMoreProducts';
import Sliders from './sliders';

const $ = jQuery.noConflict();
import LazyLoad from './lazyLoad';
import Popup from './popup';
import Select2 from './select2';

'use strict';
const LoadCategoryProducts = {
	/*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/
	$wrapper: $('.js-category-resource-wrap'),
	/*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
	init: function() {
		this.loadMorePosts();
	},
	loadMorePosts: function() {
		const btn = $('.js-products-block__wrap-select');
		if (btn) {
			btn.on('change', function() {
				if(!Select2.clearingFilter){
					return false;
				}
				$('.product-block__filters--loader-icon').addClass('is-active');

				$('body').addClass('category');
				const taxonomyCatIds = document.querySelectorAll('.js-products-block__wrap-select');
				let supplementType;
				let mainBenefit;
				let feature;
				let age;
				for (let i = 0; i < taxonomyCatIds.length; i++) {
					const dataName = taxonomyCatIds[i].getAttribute('data-name');
					const value = taxonomyCatIds[i].options[taxonomyCatIds[i].selectedIndex].value;
					if(dataName === 'supplement-type' && value !== undefined) {
						supplementType = value;
					}
					if(dataName === 'feature' && value !== undefined) {
						feature = value;
					}
					if(dataName === 'main-benefit' && value !== undefined) {
						mainBenefit = value;
					}
					if(dataName === 'age' && value !== undefined) {
						age = value;
					}
				}
				const obj = {
					supplementType,
					feature,
					mainBenefit,
					age
				};
				LoadMoreProducts.page = 1;
				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: fwsLocalized.ajaxUrl,
					data: {
						action: 'LoadMoreCategoryProducts',
						catIds: obj
					},
					success: function(response) {
						$('.product-block__filters--loader-icon').removeClass('is-active');
						if(response){
							$('.js-post-wrap').empty();
							$('.js-category-resource-wrap').append(response.htmlResources);
							if (response.count_posts > 12) {
								$('.js-load-more').removeClass('hidden');
							} else {
								$('.js-load-more').addClass('hidden');
							}
							LazyLoad.init();
							LoadMoreProducts.init();
							Popup.init();
							Sliders.init();
						}else {
							$('.js-post-wrap').empty();
							if(obj.supplementType !== '' || obj.mainBenefit !== '' || obj.mainBenefit !== '' || obj.age !== ''){
								$('.js-category-resource-wrap').append('<span class="products-block__no-results">No results found</span>');
							}
						}
					}
				});
			});
		}
	}
};

export default LoadCategoryProducts;
